import { useCallback, type ReactNode } from "react";
import type { SxProps } from "@mui/material";
import { ListItem, Tooltip, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import type { NavigationEntryAction } from "./models/NavigationEntry";
import { useSnackbarErrorHandler } from "utils/errorHandling";

const listItemButtonStyle: SxProps = {
  borderRadius: 1,
  "&:hover": { backgroundColor: "primary.light" },
  "&.Mui-selected, &.Mui-selected:hover": {
    backgroundColor: "primary.main",
    color: "white",
  },
  "&.Mui-selected .MuiTypography-root": { color: "white" },
};

interface MenuActionEntryProps {
  navigationEntry: NavigationEntryAction;
  isOpen: boolean;
}

function MenuActionEntry({ navigationEntry, isOpen }: Readonly<MenuActionEntryProps>): ReactNode {
  const { libelle, icon, onClick } = navigationEntry;
  const { isLoading, catchErrors } = useSnackbarErrorHandler();
  const doAction = useCallback(() => {
    void catchErrors(onClick);
  }, [catchErrors, onClick]);

  return (
    <ListItem disablePadding>
      <Tooltip title={libelle} placement="right" disableHoverListener={isOpen}>
        <ListItemButton disabled={isLoading} onClick={doAction} sx={listItemButtonStyle}>
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: isOpen ? 2 : "auto",
              color: "inherit",
            }}>
            {icon}
          </ListItemIcon>
          <ListItemText primary={libelle} sx={{ opacity: isOpen ? 1 : 0 }} />
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
}

export default MenuActionEntry;
